// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2GFoL","colMaxWidth":"Table_colMaxWidth__bXSwx"};